<!-- 产品展示 -->
<template>
	<div class="aboutUs">
		<div class="imgBg"></div>
		<div class="boxWidth">
			<el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
				<el-tab-pane :label="item.label" :name="item.id" v-for="item in products" :key="item.id">
					<div class="boxWidth-nei" v-if="item.id == activeName">
						<leftMenu :leftMenu="item.proMenuList" @childClick = 'handleChildClick'></leftMenu>
						<div class="solutionRight">
							<h3 class="title">{{item.proMenuList[iscurLeft].title  }}</h3>
							<!-- <h3 class="title">{{flagJs(item.proMenuList[$store.state.iscurLeft]) }}</h3> -->
							<!-- 软件产品 -->
							<div  v-if="iscurLeft == 0 && activeName == '1'">
								<p class="mainP">{{$t('hexiEarth_p1')}}</p>
								<p class="mainP">{{$t('hexiEarth_p2')}}</p>
								<p class="mainP">{{$t('hexiEarth_p3')}}</p>
								<img src="../assets/img/product/1earth1.png" alt="">
								<p class="mainP">{{$t('hexiEarth_p4')}}</p>
								<img src="../assets/img/product/1earth2.png" alt="">
								<h4 >{{$t('hexiEarth_p5')}}</h4>
								<p class="mainP">{{$t('hexiEarth_p6')}}</p>
								<p class="mainP">{{$t('hexiEarth_p7')}}</p>
								<p class="mainP">{{$t('hexiEarth_p8')}}</p>
								<p class="mainP">{{$t('hexiEarth_p9')}}</p>
								<img src="../assets/img/product/1earth3.png" alt="">
								<h4>{{$t('hexiEarth_p10')}}</h4>
								<p class="mainP">{{$t('hexiEarth_p11')}}</p>
							</div>
							<div v-if="iscurLeft == 1 && activeName == '1'">
								<!-- HexiPanoVR -->
								<p class="mainP">{{$t('hexiPanoVr_p1')}}</p>
								<img src="../assets/img/product/1vr1.png" alt="">
								<p class="mainP">{{$t('hexiPanoVr_p2')}}</p>
								<img src="../assets/img/product/1vr2.png" alt="">
								<h4>{{$t('hexiPanoVr_p3')}}</h4>
								<p class="mainP">{{$t('hexiPanoVr_p4')}}</p>
								<img src="../assets/img/product/1vr3.png" alt="">
								
							</div>
							<div v-if="iscurLeft == 2 && activeName == '1'">
								<!-- HexiOrtho -->
								<p class="mainP">{{$t('hexiOrtho_p1')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p2')}}</p>
								<img src="../assets/img/product/1ortho1.png" alt="">
								<p class="mainP">{{$t('hexiOrtho_p3')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p4')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p5')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p6')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p7')}}</p>
								<img src="../assets/img/product/1ortho2.png" alt="">
								<p class="imgFont">{{$t('hexiOrtho_p8')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p9')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p10')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p11')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p12')}}</p>
								<img src="../assets/img/product/1ortho3.png" alt="">
								<p class="imgFont">{{$t('hexiOrtho_p13')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p14')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p15')}}</p>
								<img src="../assets/img/product/1ortho4.png" alt="">
								<p class="imgFont">{{$t('hexiOrtho_p16')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p17')}}</p>
								<p class="mainP">{{$t('hexiOrtho_p18')}}</p>
								<img src="../assets/img/product/1ortho5.png" alt="">
							</div>
							<div v-if="iscurLeft == 3 && activeName == '1'">
								<p class="mainP">{{$t('hexiUAV_p1')}}</p>
								<img src="../assets/img/product/1uav1.png" alt="">
								<p class="mainP">{{$t('hexiUAV_p2')}}</p>
								<p class="mainP">{{$t('hexiUAV_p3')}}</p>
								<p class="mainP">{{$t('hexiUAV_p4')}}</p>
								<p class="mainP">{{$t('hexiUAV_p5')}}</p>
								<p class="mainP">{{$t('hexiUAV_p6')}}</p>
								<p class="mainP">{{$t('hexiUAV_p7')}}</p>
								<p class="mainP">{{$t('hexiUAV_p8')}}</p>
								<p class="mainP">{{$t('hexiUAV_p9')}}</p>
								<p class="mainP">{{$t('hexiUAV_p10')}}</p>
								<p class="mainP">{{$t('hexiUAV_p11')}}</p>
								<p class="mainP">{{$t('hexiUAV_p12')}}</p>
								<p class="mainP">{{$t('hexiUAV_p13')}}</p>
								<p class="mainP">{{$t('hexiUAV_p14')}}</p>
								<p class="mainP">{{$t('hexiUAV_p15')}}</p>
								<p class="mainP">{{$t('hexiUAV_p16')}}</p>
								<p class="mainP">{{$t('hexiUAV_p17')}}</p>
								<p class="mainP">{{$t('hexiUAV_p18')}}</p>
								<p class="mainP">{{$t('hexiUAV_p19')}}</p>
								<p class="mainP">{{$t('hexiUAV_p20')}}</p>
								<p class="mainP">{{$t('hexiUAV_p21')}}</p>
								<p class="mainP">{{$t('hexiUAV_p22')}}</p>
								<p class="mainP">{{$t('hexiUAV_p23')}}</p>
								<img src="../assets/img/product/1uav2.png" alt="">
								<p class="mainP">{{$t('hexiUAV_p24')}}</p>
								<p class="mainP">{{$t('hexiUAV_p25')}}</p>
								<p class="mainP">{{$t('hexiUAV_p26')}}</p>
								<img src="../assets/img/product/1uav3.png" alt="">
								<img src="../assets/img/product/1uav4.png" alt="">
								<img src="../assets/img/product/1uav5.png" alt="">
							</div>
							<!-- 卫星数据产品 -->
							 <!-- GF1 -->
							<div v-if="iscurLeft == 0 && activeName == '2'">
								<p class="mainP" v-for="(item,index) in weixingIntroGF1" :key="index">
									{{ item.word_item }}
								</p>
								<img src="../assets/img/product/2gaofen1.png" alt="">
							</div>
							<!-- ganfen2 -->
							<div v-if="iscurLeft == 1 && activeName == '2'">
								<p class="mainP" v-for="(item,index) in weixingIntroGF2" :key="index">
									{{ item.word_item }}
								</p>
								<img src="../assets/img/product/2gaofen2.png" alt="">
							</div>
							<!-- ZY3 -->
							<div v-if="iscurLeft == 2 && activeName == '2'">
								<p class="mainP" v-for="(item,index) in weixingIntroZY3" :key="index">
									{{ item.word_item }}
								</p>
								<img src="../assets/img/product/2ziyuan1.png" alt="">
							</div>
							<!-- superView -->
							<div v-if="iscurLeft == 3 && activeName == '2'">
								<p class="mainP" v-for="(item,index) in weixingIntroSuperView" :key="index">
									{{ item.word_item }}
								</p>
								<img src="../assets/img/product/2gaojing1.png" alt="">
							</div>
							<!-- WorldView -->
							<div v-if="iscurLeft == 4 && activeName == '2'">
								<h3>{{$t('WorldView_p1')}}</h3>
								<p class="mainP">{{$t('WorldView_p2')}}</p>
								<img src="../assets/img/product/2wv1.png" alt="">
								<h3>{{$t('WorldView_p3')}}</h3>
								<p class="mainP">{{$t('WorldView_p4')}}</p>
								<p class="mainP">{{$t('WorldView_p5')}}</p>
								<h4>{{$t('WorldView_p6')}}</h4>
								<p class="mainP">{{$t('WorldView_p7')}}</p>
								<p class="mainP">{{$t('WorldView_p8')}}</p>
								<p class="mainP">{{$t('WorldView_p9')}}</p>
								<p class="mainP">{{$t('WorldView_p10')}}</p>
								<img src="../assets/img/product/2wv2.png" alt="">
								<h3>{{$t('WorldView_p11')}}</h3>
								<p class="mainP">{{$t('WorldView_p12')}}</p>
								<p class="mainP">{{$t('WorldView_p13')}}</p>
								<!-- <h4>效果展示</h4> -->
								<img src="../assets/img/product/2wv3.png" alt="">
								<h3>{{$t('GeoEye_p1')}}</h3>
								<p class="mainP" v-for="(item,index) in GeoEyeLists" :key="index">{{ item. word_item}}</p>
								<img src="../assets/img/product/2wv4.png" alt="">
							</div>
							<!-- spot -->
							<div v-if="iscurLeft == 5 && activeName == '2'">
								<h3>{{$t('spot_p1')}}</h3>
								<p class="mainP">{{$t('spot_p2')}}</p>
								<h4>{{$t('spot_p3')}}</h4>
								<p class="mainP">{{$t('spot_p4')}}</p>
								<p class="mainP">{{$t('spot_p5')}}</p>
								<h4>{{$t('spot_p6')}}</h4>
								<p class="mainP">{{$t('spot_p7')}}</p>
								<h4>{{$t('spot_p8')}}</h4>
								<p class="mainP">{{$t('spot_p9')}}</p>
								<p class="mainP">{{$t('spot_p10')}}</p>
								<p class="mainP">{{$t('spot_p11')}}</p>
								<p class="mainP">{{$t('spot_p12')}}</p>
								<h4>{{$t('spot_p13')}}</h4>
								<p class="mainP">{{$t('spot_p14')}}</p>
								<h4>{{$t('spot_p15')}}</h4>
								<p class="mainP">{{$t('spot_p16')}}</p>
								
								<img src="../assets/img/product/2airbus1.png" alt="">
								<h3>{{$t('pleiades_p1')}}</h3>
								<p class="mainP">{{$t('pleiades_p2')}}</p>
								<p class="mainP">{{$t('pleiades_p3')}}</p>
								<h4>{{$t('pleiades_p4')}}</h4>
								<p class="mainP">{{$t('pleiades_p5')}}</p>
								<p class="mainP">{{$t('pleiades_p6')}}</p>
								<p class="mainP">{{$t('pleiades_p7')}}</p>
								<p class="mainP">{{$t('pleiades_p8')}}</p>
								<p class="mainP">{{$t('pleiades_p9')}}</p>
								<p class="mainP">{{$t('pleiades_p10')}}</p>
								<img src="../assets/img/product/2airbus2.png" alt="">
							</div>
							<!-- 硬件产品 -->
							<div v-if="activeName == '3'">
								<p style="text-align: center;">{{$t('liyade_p1')}}</p>
								<p style="margin-bottom:20px;">{{$t('liyade_p2')}}</p>
								<div class="hardware">
									<div class="liyade" v-for="(item,index) in liyades" :key="index">
										<p class="bigTitle">{{item.oneTitle}}</p>
										<p class="secondTitle">{{item.twoTitle}}</p>
										<img :src=item.liyadeImg alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import leftMenu from './leftMenu.vue'
	export default {
	  components: {leftMenu},
	  data() {
	    return {
			activeName: '1',	
			iscurLeft:0,		
		}
	  },
	  computed: {
			products() {
				return this.$t('productsLeftMenuList'); // 获取翻译的menus
			},
			liyades(){
				return this.$t('liyades'); // 获取翻译的liyades
			},
			weixingIntroGF1(){
				return this.$t('weixingIntroGF1');
			},
			weixingIntroGF2(){
				return this.$t('weixingIntroGF2');
			},
			weixingIntroZY3(){
				return this.$t('weixingIntroZY3');
			},
			weixingIntroSuperView(){
				return this.$t('weixingIntroSuperView');
			},
			GeoEyeLists(){
				return this.$t('GeoEyeLists');
			}

		},
	  watch: {
		'$route.path': {
			handler(newVal, oldVal) {
				//判断newVal有没有值监听路由变化
				this.$nextTick(()=>{
					if (newVal == '/solution') {
						// console.log('当前路由',newVal)
						// console.log('上一个路由',oldVal)
						this.iscurLeft = 0
					}
				})
			},
			deep: true
		},
	  },
	  methods:{
		handleChildClick(index){
			this.iscurLeft = index
		},
		handleClick(){
			this.iscurLeft = 0
		},
		// flagJs(data){
		// 	console.log('data',data)
		// 	return data.title
		// }
	  }
	}
</script>
<style scoped lang="scss">
 .imgBg{
	background-image: url('../assets/img/probanner.png');
  }
  .boxWidth-nei{
	display: flex;
  }
  h3,h4{
	// text-indent: 2em;
	margin-bottom:10px;
	margin-top:20px;
  }
  .hardware{
	  display: flex;
	  flex-wrap: wrap;
  }
  .liyade{
	  width :47%;
	  height: 250px;
	  background-color: #fff;
	  border-radius: 15px;
	  box-shadow: 0 5px 7px #595959;
	  margin: 10px;
	  padding-top:30px ;
	  overflow: hidden;
	  
	  p{
		  text-align: center; 
		  margin-bottom: 10px;
	  }
	  p.bigTitle{
		  font-size: 20px;
		  font-weight: bold;
		  color:#595959;
	  }
	  p.secondTitle{
		  color:#a5a5a5;
		  
	  }
	  img{
		  width:64%;
	  }
  }
</style>